import { Pressable, Text, TextStyle, StyleSheet } from 'react-native';
import React, { ReactNode } from 'react';
import { Href } from 'expo-router/src/link/href';
import { Color, FontFamily, FontSize, Padding } from '@/GlobalStyles';
import { Link } from 'expo-router';
import { ActivityIndicator } from 'react-native-paper';

type MenuItemProps = {
  title: string | ReactNode;
  href?: Href;
  onPress?: () => void;
  textStyle?: TextStyle;
  loading?: boolean;
};

const MenuItem = (props: MenuItemProps) => {
  const { title, onPress, href, textStyle, loading = false } = props;
  if (href) {
    return (
      <Link href={href} asChild>
        <Pressable style={styles.menuButton} onPress={onPress} disabled={loading}>
          {loading ? <ActivityIndicator size={15} /> : null}
          {typeof title === 'string' ? (
            <Text style={[styles.menuTypo as TextStyle, textStyle]}>{title}</Text>
          ) : (
            title
          )}
        </Pressable>
      </Link>
    );
  }
  return (
    <Pressable style={styles.menuButton} onPress={onPress} disabled={loading}>
      {loading ? <ActivityIndicator size={15} /> : null}
      {typeof title === 'string' ? (
        <Text style={[styles.menuTypo as TextStyle, textStyle]}>{title}</Text>
      ) : (
        title
      )}
    </Pressable>
  );
};

export default MenuItem;

const styles = StyleSheet.create({
  menuButton: {
    paddingVertical: Padding.p_xs,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: Padding.p_11xl,
    columnGap: 10,
  },
  menuTypo: {
    textAlign: 'right',
    color: Color.MainNoir,
    fontFamily: FontFamily.labelMedium,
    fontWeight: '500',
    lineHeight: 18,
    fontSize: FontSize.labelMedium_size,
  },
});
